import { render, staticRenderFns } from "./PaymentBlocked.vue?vue&type=template&id=0038e40e&scoped=true&"
import script from "./PaymentBlocked.vue?vue&type=script&lang=js&"
export * from "./PaymentBlocked.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBlocked.vue?vue&type=style&index=0&id=0038e40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038e40e",
  null
  
)

export default component.exports